// extracted by mini-css-extract-plugin
export default {"range":"dateRangeInput_range__HLU4b","separator":"dateRangeInput_separator__hg4xx"};